import React, { useState, useEffect, useContext } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";

import Alert from "@material-ui/lab/Alert";

import { Context as WalletContext } from "../context/wallet.context";
import { Context as PortalContext } from "../context/portal.context";

const AddCard = (props) => {
  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [nameError, setNameError] = useState(false);
  // const [isDefault, setIsDefault] = useState(false);
  // const [autoPay, setAutoPay] = useState(false);
  const [isDefaultAch, setIsDefaultAch] = useState(false);
  const [autoPayAch, setAutoPayAch] = useState(false);
  const [routingValid, setRoutingValid] = useState(false);
  const [routingABA, setRoutingABA] = useState("");
  const [routingError, setRoutingError] = useState(false);
  const [bankAcctType, setBankAcctType] = useState("checking");
  const [bankAccountError, setBankAccountError] = useState(false);
  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
  const [confirmAccountError, setConfirmAccountError] = useState("");

  const portalState = useContext(PortalContext);
  const { addPaymentMethod } = useContext(WalletContext);
  const walletState = useContext(WalletContext);

  let history = useHistory();

  let { op } = useParams();

  useEffect(() => {}, []);

  function enableButton() {
    if (
      accountNumber !== "" &&
      accountNumber === confirmAccountNumber &&
      accountName !== "" &&
      routingValid
    ) {
      return false;
    } else return true;
  }

  const xLang = (string) => {
		return string
	}

  function validateRouting(routing) {
    // http://en.wikipedia.org/wiki/Routing_transit_number#MICR_Routing_number_format
    var checksumTotal =
      7 *
        (parseInt(routing.charAt(0), 10) +
          parseInt(routing.charAt(3), 10) +
          parseInt(routing.charAt(6), 10)) +
      3 *
        (parseInt(routing.charAt(1), 10) +
          parseInt(routing.charAt(4), 10) +
          parseInt(routing.charAt(7), 10)) +
      9 *
        (parseInt(routing.charAt(2), 10) +
          parseInt(routing.charAt(5), 10) +
          parseInt(routing.charAt(8), 10));

    var checksumMod = checksumTotal % 10;
    if (checksumMod !== 0) {
      setRoutingValid(false);
      setRoutingError(true);
    } else {
      setRoutingValid(true);
      setRoutingError(false);
    }

    setRoutingABA(routing);
  }

  function addAch() {
    let needsBeDefault = Object.keys(walletState.state.wallet).length === 0;

    addPaymentMethod(
      {
        paymentMethod: "ach",
        bankAcctType,
        accountNumber,
        nameOnAccount: accountName,
        routingABA,
        expMonth: null,
        expYear: null,
        isDefault: needsBeDefault ? needsBeDefault : isDefaultAch,
        autoPay: autoPayAch,
        op,
      },
      history
    );
  }

  return (
    <div
      style={{
        marginTop: 0,
        display: "flex",
        flexDirection: "column",
        paddingBottom: "50px",
      }}
    >
      <label
        style={{
          color: "#2f343b",
          display: "flex",
          alignSelf: "flex-start",
          marginBottom: 8,
        }}
      >
        <x-lang>Account Type</x-lang>
      </label>

      <select
        type="text"
        value={bankAcctType}
        onChange={(e) => {
          setBankAcctType(e.target.value);
        }}
        id="intellipay-card-name"
        style={{
          height: 40,
          width: "100%",
          borderRadius: 6,
          border: "1px solid #d3dce0",
          boxShadow: "inset 0px 0px 0px 0px",
          outline: "none",
          borderStyle: "solid",
          paddingLeft: 8,
          paddingRight: 8,
          fontSize: "1rem",
          fontWeight: 400,
          marginBottom: 25,
        }}
      >
        <option value="checking">{xLang("Checking")}</option>
        <option value="savings">{xLang("Savings")}</option>
      </select>
      <label
        style={{
          color: "#2f343b",
          display: "flex",
          alignSelf: "flex-start",
          marginBottom: 8,
        }}
      >
        <x-lang>Name on Account</x-lang>
      </label>
      <input
        type="text"
        value={accountName}
        onChange={(e) => {
          setAccountName(e.target.value);
          if (e.target.value.length === 0) {
            setNameError(true);
          } else {
            setNameError(false);
          }
        }}
        id="intellipay-card-name"
        style={{
          height: 40,
          width: "100%",
          borderRadius: 6,
          border: nameError ? "1px solid red" : "1px solid #d3dce0",
          boxShadow: "inset 0px 0px 0px 0px",
          outline: "none",
          borderStyle: "solid",
          boxSizing: "border-box",
          paddingLeft: 8,
          paddingRight: 8,
          fontSize: "1rem",
          fontWeight: 400,
          marginBottom: 25,
        }}
      />
      <label
        style={{
          color: "#2f343b",
          display: "flex",
          alignSelf: "flex-start",
          marginBottom: 8,
        }}
      >
        <x-lang>Bank Routing Number</x-lang>
      </label>
      <input
        type="text"
        value={routingABA}
        onChange={(e) => {
          validateRouting(e.target.value);
        }}
        id="intellipay-routing-input"
        style={{
          height: 40,
          width: "100%",
          borderRadius: 6,
          border: routingError ? "1px solid red" : "1px solid #d3dce0",
          boxShadow: "inset 0px 0px 0px 0px",
          outline: "none",
          borderStyle: "solid",
          boxSizing: "border-box",
          paddingLeft: 8,
          paddingRight: 8,
          fontSize: "1rem",
          fontWeight: 400,
          marginBottom: 25,
        }}
      />
      <label
        style={{
          color: "#2f343b",
          display: "flex",
          alignSelf: "flex-start",
          marginBottom: 8,
        }}
      >
        <x-lang>Account Number</x-lang>
      </label>
      <input
        type="text"
        value={accountNumber}
        onChange={(e) => {
          setAccountNumber(e.target.value);
          if (e.target.value.length === 0) {
            setBankAccountError(true);
          } else {
            setBankAccountError(false);
          }
        }}
        id="intellipay-ach-account"
        style={{
          height: 40,
          width: "100%",
          borderRadius: 6,
          border: bankAccountError ? "1px solid red" : "1px solid #d3dce0",
          boxShadow: "inset 0px 0px 0px 0px",
          outline: "none",
          borderStyle: "solid",
          boxSizing: "border-box",
          paddingLeft: 8,
          paddingRight: 8,
          fontSize: "1rem",
          fontWeight: 400,
          marginBottom: 25,
        }}
      />
      <label
        style={{
          color: "#2f343b",
          display: "flex",
          alignSelf: "flex-start",
          marginBottom: 8,
        }}
      >
        <x-lang>Confirm Account Number</x-lang>
      </label>
      <input
        type="text"
        value={confirmAccountNumber}
        onChange={(e) => {
          setConfirmAccountNumber(e.target.value);

          if (e.target.value.length === 0 || e.target.value !== accountNumber) {
            setConfirmAccountError(true);
          } else {
            setConfirmAccountError(false);
          }
        }}
        id="intellipay-confirm-bankAcct-name"
        style={{
          height: 40,
          width: "100%",
          borderRadius: 6,
          border: confirmAccountError ? "1px solid red" : "1px solid #d3dce0",
          boxShadow: "inset 0px 0px 0px 0px",
          outline: "none",
          borderStyle: "solid",
          boxSizing: "border-box",
          paddingLeft: 8,
          paddingRight: 8,
          fontSize: "1rem",
          fontWeight: 400,
          marginBottom: 25,
        }}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          justifyContent: "flex-start",
        }}
      >
        <div>
          <input
            type="checkbox"
            style={{ marginRight: 25 }}
            checked={isDefaultAch}
            onChange={(e) => setIsDefaultAch(e.target.checked)}
          ></input>
          <label><x-lang>Set as default</x-lang></label>
        </div>
        <Button
          variant={"contained"}
          disabled={enableButton()}
          color="secondary"
          style={{ width: "100%", height: 50, color: "white", marginTop: 25 }}
          onClick={() => addAch()}
        >
          <x-lang>Save</x-lang>
        </Button>
      </div>
      {/* {portalState.state.allowAutoPay ? (
        <>
          <Alert
            severity="warning"
            style={{
              marginBottom: 0,
              marginTop: 15,
              boxSizing: "border-box",
              width: "100%",
              textAlign: "left",
            }}
          >
            <b>IMPORTANT:</b> Enabling the “Auto Pay” feature will automatically
            trigger a charge to this card for the full amount of any invoice on
            its due date. This also means that any invoices that are past due
            will also be paid immediately.{" "}
          </Alert>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "flex-start",
              marginTop: 15,
              marginBottom: 25,
            }}
          >
            <input
              type="checkbox"
              style={{ marginRight: 25 }}
              checked={autoPayAch}
              onChange={(e) => setAutoPayAch(e.target.checked)}
            ></input>
            <label>Auto Pay</label>
          </div>
        </>
      ) : null} */}
    </div>
  );
};

export default AddCard;
